import {useTelegram} from "./useTelegram"

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const {user} = useTelegram()

      console.log(user)
      if (user) {
        config.headers.Authorization = user.id
      }

      return config
    },
    (err: any) => {      
      Promise.reject(err)
    }
  )

  // axios.interceptors.response.use(function (response: any) {
  //   // Any status code that lie within the range of 2xx cause this function to trigger
  //   // Do something with response data
  //   return response;
  // }, function (error: any) {
  //   // Any status codes that falls outside the range of 2xx cause this function to trigger
  //   // Do something with response error

  //   switch (error.response?.status) {
  //     case 401:
  //       customHistory.push(APP_URL.AUTH_LOGIN)
  //       return Promise.resolve()
  //     case 403:
  //       customHistory.push(APP_URL.ERROR_403)
  //       return Promise.resolve()
  //   }

  //   return Promise.reject(error);
  // });
}